import { forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import { useThemeValues } from '../../../hooks';
import { Button } from '../../button/button.component';
import { ButtonRef } from '../button-type';
import { PrimaryButtonStyles } from './primary-button.styles';
import { PrimaryButtonProps } from './types';
/** @deprecated Instead, please use `<Button variant='primary'>` from `@frontend/design-system` */
export const PrimaryButton = forwardRef<ButtonRef, PrimaryButtonProps>(
  ({ children, destructive, size = 'small', trackingId, type = 'button', className, ...rest }, ref) => {
    const styles = PrimaryButtonStyles.primaryButton({ destructive, size });
    const theme = useThemeValues();

    return theme.name === 'spark' ? (
      <Button
        variant='primary'
        type={type}
        size={size === 'tiny' ? 'large' : size}
        destructive={destructive}
        {...rest}
        className={className}
        ref={ref}
        data-trackingid={trackingId}
      >
        {children}
      </Button>
    ) : (
      <button className={cx(styles, className)} type={type} {...rest} ref={ref} data-trackingid={trackingId}>
        {children}
      </button>
    );
  }
);
